<template>
  <div class="container container--fluid" style="padding: 0">
    <div class="ribbon ribbon-top-left" v-if="env !== 'production'"><span>DEMO</span></div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="10">
        <v-card class="elevation-12 mb-3">
          <v-card-text class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <div class="bg-kiri white--text">
                  <div class="pa-12">
                    <div style="line-height: 2em" class="mb-5">
                      <div style="font-size: 1.5rem" class="ma-0">Ayo mulai</div>
                      <div style="font-size: 2.3rem" class="font-weight-bolder">
                        Mendaftar
                      </div>
                    </div>
                    <em>
                      " Apapun yang dilakukan oleh seseorang itu, hendaknya dapat bermanfaat bagi dirinya sendiri,
                      bermanfaat bagi bangsanya, dan bermanfaat bagi manusia di dunia pada umumnya. "
                    </em>
                    <v-divider dark style="border-top: 1px solid #ffffff; margin: 1rem 0"></v-divider>
                    <div>
                      <p class="font-weight-bolder">Ki Hajar Dewantara</p>
                    </div>
                  </div>
                  <div
                    class="px-12 text-center white--text"
                    style="position: absolute; left: 10px; bottom: 2rem; line-height: 1.2rem; opacity: 0.7"
                  >
                    <small>
                      Copyright © 2021, <br />
                      Program Sekolah Penggerak, All rights reserved.
                    </small>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="8">
                <router-view :key="$route.fullPath" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'GuestView',
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto+Slab:400,700,900&display=swap');

body {
  font-family: 'Roboto Slab', serif;
  background: linear-gradient(to bottom right, #7ff2ff, #549dff);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
}

.card-box {
  background-color: #fff;
  border-radius: 5px;
}

.bg-kiri {
  background: #0092de;
  background-image: url('https://cdn.siap.id/s3/simpkb/asset img/PPG-2020/register/bg-register1.png');
  background-repeat: no-repeat;
  margin: 0px;
  border-radius: 5px 0 0 0;
  height: 100%;
}

.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: fixed;
  z-index: 100000;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #cc0000;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #cc0000;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top left*/
.ribbon-top-left {
  top: -10px;
  left: -10px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}
</style>
